import React from "react";
import { Plus } from "lucide-react";
import ProjectForm from "./components/ProjectForm";

const AddProject = () => {
  return <ProjectForm isEdit={false} submitIcon={Plus} />;
};

export default AddProject;
